class AnalyticsManager {
    constructor() {
        this.initializeDataLayer();
    }

    initializeDataLayer() {
        window.dataLayer = window.dataLayer || [];
    }

    pushEvent(eventData) {
        if (window.dataLayer) {
            window.dataLayer.push(eventData);
            console.log('DataLayer push completed:', eventData);
        } else {
            console.warn('dataLayer not found - would have pushed:', eventData);
        }
    }

    // Form submission tracking
    trackFormSubmission(formType, formData = {}, location = null) {
        // const baseEventData = {
        //     'event': 'form_submission',
        //     'event_category': 'Forms',
        //     'event_label': formType,
        // };
        //
        // this.pushEvent(baseEventData);form/complete

        // Track specific form types
        switch (formType) {
            case 'sendmessage':
                this.pushEvent({
                    'event': 'send_message',
                });
                break;
            case 'request_quote':
                this.pushEvent({
                    'event': 'request_quote',
                });
                break;
            case 'newsletter':
                this.pushEvent({
                    'event': 'newsletter_signup',
                });
                break;
            case 'contactme':
                this.pushEvent({
                    'event': 'contact_me',
                    ...(location ? { 'location': location } : {})
                });
                break;
            case 'customer_interest':
                this.pushEvent({
                    'event': 'contact_me',
                });
                break;
            case 'cybersecurity_order':
                this.pushEvent({
                    'event': 'cyberguard_order',
                });
                break;
        }
    }

    // Click tracking
    trackPhoneClick(phoneNumber) {
        this.pushEvent({
            'event': 'click_phone',
        });
    }

    trackEmailClick(email) {
        this.pushEvent({
            'event': 'click_email',
        });
    }

    trackServiceGuideSubmission(formData) {
        const eventData = {
            'event': 'service_guide_submission',
            'securitysolution': formData.selectedService,
        };

        // Add dynamic answer fields from the questions
        formData.answers.forEach(answerObj => {
            const questionField = answerObj.question.formField;
            // Handle multiple answers by joining them with comma
            const answerValue = Array.isArray(answerObj.answer)
                ? answerObj.answer.join(',')
                : answerObj.answer;

            eventData[questionField] = answerValue;
        });

        this.pushEvent(eventData);
    }

    trackCustomEvent(eventType, additionalData = {}) {
        this.pushEvent({
            'event': eventType,
            ...additionalData
        });
    }

    // Setup click handlers
    setupClickTracking() {
        // Phone click tracking
        document.querySelectorAll('a[href^="tel:"]').forEach(link => {
            link.addEventListener('click', () => {
                const phoneNumber = link.href.split(":")[1];
                this.trackPhoneClick(phoneNumber);
            });
        });

        // Email click tracking
        document.querySelectorAll('a[href^="mailto:"]').forEach(link => {
            link.addEventListener('click', () => {
                const email = link.href.split(":")[1];
                this.trackEmailClick(email);
            });
        });

        // Custom GA event tracking
        document.querySelectorAll('[data-ga]').forEach(element => {
            const eventType = element.getAttribute('data-ga-event');

            if (!eventType) {
                return; // Skip if no event type is specified
            }

            if (eventType === 'click_read_details') 
            {
                element.addEventListener('click', () => {
                    // Find the closest parent section with the correct ID
                    const section = element.parentElement.querySelector('#see-more-details');
                    // Only add event listener if section exists and is hidden
                    if (!section?.classList.contains('hidden')) {
                        this.trackCustomEvent(eventType);
                    }
                });
                return;
            }

            // For all other event types
            element.addEventListener('click', () => {
                this.trackCustomEvent(eventType);
            });
        });
    }
}

// Export a singleton instance
export const analyticsManager = new AnalyticsManager();